import React from "react";
import styles from "./style.module.css";

const PlanCard = ({
  title,
  description,
  monthlyCharge,
  features,
  smallDesc,
}) => {
  return (
    <div className={styles.planCard}>
      <h4 className={styles.heading}>{title}</h4>
      <p className={styles.desc}>{description}</p>

      <p className={styles.rent}>
        <span className={styles.charges}> {monthlyCharge} </span>{" "}
        <span className={styles.month}>/month</span>{" "}
        <span className={styles.chargeFor}>{smallDesc} </span>{" "}
      </p>
      <hr />
      <ul className={styles.allItems}>
        {features.map((feature, index) => (
          <li className={styles.listItem} key={index}>
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PlanCard;
